import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AvailableLanguages } from '@constants';
import { User, UserProcess } from '@interfaces';

@Component({
  selector: 'app-perm-stay-step6',
  templateUrl: './perm-stay-step6.component.html',
  styleUrls: ['./perm-stay-step6.component.scss'],
  standalone: false,
})
export class PermStayStep6Component implements OnInit, AfterViewInit, OnDestroy {
  private readonly translateService = inject(TranslateService);

  @Input() formGroup: FormGroup;
  @Input() mode: 'foreigner' | 'employee';
  @Input() user: User;
  @Input() userProcess: UserProcess;
  @Output() firstInputShiftTabPressed: EventEmitter<void> = new EventEmitter<void>();
  @Output() lastFieldTabPressed: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() toggleVerificationOfPersonalDetails: EventEmitter<void> = new EventEmitter();

  public controls: { [key: string]: FormControl } = {};
  public currentLang: AvailableLanguages;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  public ngOnInit(): void {
    this.currentLang = this.translateService.currentLang as AvailableLanguages;

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(({ lang: langKey }) => {
      this.currentLang = langKey as AvailableLanguages;
    });

    Object.keys(this.formGroup.controls).forEach(fieldName => {
      this.controls[fieldName] = this.formGroup.controls[fieldName] as FormControl;
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.hasAnyFieldAnyValue(this.formGroup.controls)) {
        this.formGroup.markAllAsTouched();
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public firstInputKeydown($event: KeyboardEvent): void {
    if (!$event.shiftKey) {
      return;
    }

    if ($event.key?.toLowerCase() !== 'tab') {
      return;
    }

    this.firstInputShiftTabPressed.emit();
  }

  public emitLastFieldTabPressed($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    this.lastFieldTabPressed.emit($event);
  }

  private hasAnyFieldAnyValue(controls: { [key: string]: AbstractControl }): boolean {
    return Object.keys(controls).some(controlName => {
      const val = controls[controlName].value;

      if (Array.isArray(val) && val.length > 0) {
        return true;
      }

      return val !== '' && val !== undefined && val !== null;
    });
  }
}
